
export class OneLinePower {
  constructor() {
    // 1号主发电机开关
    this.generator1Switch = false
    // 1号主发电机2开关
    this.generator2Switch = false
    // 1号主发电机3开关
    this.generator3Switch = false
    // 102开关
    this.switch102 = false
    // 111开关
    this.switch111 = false
    // 112开关
    this.switch112 = false
    // 115开关
    this.switch115MTR1 = false
    // 115开关
    this.switch115MTR2 = false
    // ETR1 95开关
    this.switch95MTR1 = false
    // ETR2 95开关
    this.switch95MTR2 = false
    // 回流排开关
    this.returnFlowSwitch = false
    // P2-7 93开关
    this.p27Switch93 = false
    // P2-8 93开关
    this.p28Switch93 = false
    // 岸电开关
    this.shipPowerSwitch = false
    // 隔离开关
    this.separateSwitch = false
    // 应发开关
    this.dispatchSwitch = false
    // 1号主发电机1数值
    this.generator1 = {
      // 1号主发电机电压
      voltage: 0,
      // 1号主发电机电流
      current: 0,
      // 1号主发电机功率
      power: 0,
      // 1号主发电机频率
      frequency: 0,
    }
    // 1号主发电机2数值
    this.generator2 = {
      // 1号主发电机2电压
      voltage: 0,
      // 1号主发电机2电流
      current: 0,
      // 1号主发电机2功率
      power: 0,
      // 1号主发电机2频率
      frequency: 0,
    }
    // 1号主发电机3数值
    this.generator3 = {
      // 1号主发电机3电压
      voltage: 0,
      // 1号主发电机3电流
      current: 0,
      // 1号主发电机3功率
      power: 0,
      // 1号主发电机3频率
      frequency: 0,
    }
    // 440v主汇流排数值
    this.mainStream1 = {
      // 440v主汇流排电压
      voltage: 0,
      // 440v主汇流排电流
      current: 0,
      // 440v主汇流排功率
      power: 0,
      // 440v主汇流排频率
      frequency: 0,
    }
    // 440v主汇流排2数值
    this.mainStream2 = {
      // 440v主汇流排2电压
      voltage: 0,
      // 440v主汇流排2电流
      current: 0,
      // 440v主汇流排2功率
      power: 0,
      // 440v主汇流排2频率
      frequency: 0,
    }
    // 400v应急流排数值
    this.emergencyStream = {
      // 400v应急流排电压
      voltage: 0,
      // 400v应急流排电流
      current: 0,
      // 400v应急流排功率
      power: 0,
      // 400v应急流排频率
      frequency: 0,
    }
    // 岸电箱数值
    this.shipPowerBox = {
      // 岸电箱电压
      voltage: 0,
      // 岸电箱电流
      current: 0,
      // 岸电箱功率
      power: 0,
      // 岸电箱频率
      frequency: 0,
    }
    // 应急发电机数值
    this.emergencyGenerator = {
      // 应急发电机电压
      voltage: 0,
      // 应急发电机电流
      current: 0,
      // 应急发电机功率
      power: 0,
      // 应急发电机频率
      frequency: 0,
    }
    // 1号主发电机1电源
    this.generator1Power = false
    // 1号主发电机2电源
    this.generator2Power = false
    // 1号主发电机3电源
    this.generator3Power = false
    // 应急发电机能源
    this.emergencyGeneratorEnergy = false
  }
}